import { apiGetTicketScheduleList, apiRetryTicketScheduleEvent } from "services/TicketScheduleService"
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"


export const getTicketSchedule = createAsyncThunk(
    'ticketSchedule/get',
    async (data, { rejectWithValue }) => {
        try {
            const response = await apiGetTicketScheduleList(data)
            return response.data
        } catch (error) {
            return rejectWithValue(error?.response?.data ?? { message: 'Error' })
        }
    }
)


export const retryTicketScheduleEvent = createAsyncThunk(
    'ticketSchedule/retry',
    async (eventId, { rejectWithValue }) => {
        try {
            const response = await apiRetryTicketScheduleEvent(eventId)
            return { eventId, data: response.data }
        } catch (error) {
            return rejectWithValue(error?.response?.data ?? { message: 'Error' })
        }
    }
)

export const buildScheduleQuery = ({ page = 1, search = '', searchField = 'all', recurrence = '', sort = '-start_time' } = {}) => {
    const params = ['filter[is_parent]=true', `page[number]=${page}`]
    if (search.trim()) {
        const key = searchField === 'all' ? 'search' : searchField
        params.push(`filter[${key}]=${encodeURIComponent(search.trim())}`)
    }
    if (recurrence) params.push(`filter[recurrence]=${recurrence}`)
    if (sort) params.push(`sort=${sort}`)
    return `/ticket_schedule?${params.join('&')}`
}

export const initialTableData = {
    total: 0,
    pageIndex: 1,
    pageSize: 30,
    query: '/ticket_schedule?filter[is_parent]=true&sort=-start_time',
}

const initialState = {
    ticketScheduleList: [],
    ticketScheduleSelected: null,
    editingChildEvent: null,
    loadingTicketSchedule: false,
    tableData: initialTableData,
}


const dataSlice = createSlice({
    name: 'ticketSchedule/data',
    initialState,
    reducers: {
        setTicketScheduleList: (state, action) => {
            state.ticketScheduleList = action.payload
        },
        setTicketScheduleSelected: (state, action) => {
            state.ticketScheduleSelected = action.payload
        },
        setEditingChildEvent: (state, action) => {
            state.editingChildEvent = action.payload
        },
        setTableData: (state, action) => {
            state.tableData = action.payload
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getTicketSchedule.pending, (state) => {
                state.loadingTicketSchedule = true
            })
            .addCase(getTicketSchedule.fulfilled, (state, action) => {
                const { data, meta } = action.payload
                if (meta) {
                    state.tableData.total = meta.total
                    state.tableData.pageIndex = meta.current_page
                    state.tableData.pageSize = meta.per_page
                }

                state.ticketScheduleList = data
                state.loadingTicketSchedule = false
            })
            .addCase(getTicketSchedule.rejected, (state) => {
                state.loadingTicketSchedule = false
            })
    }
})

export const {
    setTicketScheduleList,
    setTicketScheduleSelected,
    setEditingChildEvent,
    setTableData
} = dataSlice.actions

export default dataSlice.reducer
